/**
 * Portuguese Quote Translations
 * 报价弹窗翻译模块 - 葡萄牙语
 * 
 * 包含获取报价表单和弹窗等翻译
 */

import type { QuoteTranslations } from '../../types';

export const ptQuote: QuoteTranslations = {
  getQuote: 'Obter Cotação',
  title: 'Obtenha uma Cotação Grátis',
  modal: {
    title: 'Obtenha uma Cotação Grátis',
    subtitle: 'Preencha os detalhes abaixo e nossa equipe entrará em contato em 24 horas.',
    fullName: 'Nome Completo',
    email: 'E-mail',
    phone: 'Telefone',
    productInterest: 'Produto de Interesse',
    message: 'Mensagem',
    placeholderName: 'João Silva',
    placeholderEmail: 'joao@example.com',
    placeholderPhone: '+55 11 00000-0000',
    placeholderProduct: 'ex., Aquecedor Industrial',
    placeholderMessage: 'Detalhes do projeto, quantidade, requisitos de tensão...',
    submit: 'Enviar Solicitação',
    successTitle: 'Solicitação Recebida!',
    successMessage: 'Obrigado pelo seu interesse. Um de nossos especialistas em aquecimento revisará seus requisitos e entrará em contato em breve.',
    close: 'Fechar',
  },
  name: 'Seu Nome',
  email: 'Endereço de E-mail',
  phone: 'Número de Telefone',
  company: 'Nome da Empresa',
  message: 'Mensagem',
  submit: 'Enviar Solicitação',
  success: 'Obrigado! Entraremos em contato em breve.',
};
